/* eslint-env browser */
import React from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router/lib/Link';
import urlMapping from '../app/URLMapping';

function getOrgIdForUrl(org) {
    if (!org) return null;
    return org.realId || org.id || null;
}

export function computeBilledByChain({ sourceOrg, billedByOrg, maxDepth = 10 }) {
    const chain = [];
    if (!sourceOrg) {
        return { chain, finalOrg: null, truncated: false, cycle: false };
    }

    chain.push(sourceOrg);

    if (!billedByOrg) {
        return { chain, finalOrg: sourceOrg, truncated: false, cycle: false };
    }

    const visited = new Set();
    const sourceId = getOrgIdForUrl(sourceOrg);
    if (sourceId) visited.add(String(sourceId));

    let current = billedByOrg;
    let depth = 0;
    while (current && depth < maxDepth) {
        const currentId = getOrgIdForUrl(current);
        if (currentId && visited.has(String(currentId))) {
            return { chain, finalOrg: chain[chain.length - 1] || null, truncated: false, cycle: true };
        }
        if (currentId) visited.add(String(currentId));

        chain.push(current);
        current = current.billedBy;
        depth += 1;
    }

    const truncated = Boolean(current);
    return { chain, finalOrg: chain[chain.length - 1] || null, truncated, cycle: false };
}

export default function BilledByChainBreadcrumb({ sourceOrg, billedByOrg, linkMode = 'edit', maxDepth = 10 }) {
    const { chain, truncated, cycle } = computeBilledByChain({ sourceOrg, billedByOrg, maxDepth });
    if (!chain || chain.length === 0) return null;

    const renderOrg = (org, idx) => {
        const idForUrl = getOrgIdForUrl(org);
        const name = (org && org.name) ? org.name : '?';
        if (!idForUrl) {
            return <span key={idx}>{name}</span>;
        }
        const to = urlMapping.getUrl('organisations', linkMode, idForUrl);
        return <Link key={idx} to={to}>{name}</Link>;
    };

    return (
        <span>
            {chain.map((org, idx) => (
                <span key={idx}>
                    {idx > 0 ? <span>{' \u2192 '}</span> : null}
                    {renderOrg(org, idx)}
                </span>
            ))}
            {truncated ? <span>{' \u2192 \u2026'}</span> : null}
            {cycle ? <span>{' \u2192 (cycle)'}</span> : null}
        </span>
    );
}

BilledByChainBreadcrumb.propTypes = {
    sourceOrg: PropTypes.object,
    billedByOrg: PropTypes.object,
    linkMode: PropTypes.oneOf(['edit', 'view']),
    maxDepth: PropTypes.number,
};

